import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../format';

export default function NotesThread({ notes, onAdd }) {
  const { t } = useTranslation('common');
  const [text, setText] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    await save();
  };

  const save = async () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    setSaving(true);
    try {
      await onAdd(trimmed);
      setText('');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="crm-notes">
      <form className="crm-note-form" onSubmit={submit}>
        <textarea
          className="crm-note-input"
          value={text}
          onChange={(event) => setText(event.target.value)}
          placeholder={t('crm.notes.placeholder')}
          rows={2}
          maxLength={4000}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !event.shiftKey) {
              event.preventDefault();
              save();
            }
          }}
        />
        <button type="submit" className="crm-btn primary" disabled={saving || !text.trim()}>
          {t('crm.notes.add')}
        </button>
      </form>

      {notes.length === 0 ? (
        <p className="crm-empty-line">{t('crm.notes.empty')}</p>
      ) : (
        <ul className="crm-note-list">
          {notes.map((note, index) => (
            <li key={`${note.created_at}-${index}`}>
              <div className="crm-note-meta">
                <strong>{note.author_name}</strong>
                <span>{formatDateTime(note.created_at)}</span>
              </div>
              <p className="crm-note-text">{note.text}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
